export default __webpack_public_path__ + "static/media/logo-synapse.199ff92b.svg";